import request from '@/utils/request';
import request2 from '@/utils/request2';
import dayjs from 'dayjs';

// 获取生态流量
/**
 *
 * @param {*}
 * deviceCode:15251065
 * beginSpt:2023-11-24 00:00:00
 * endSpt:2023-11-25 00:00:00
 * col:ecological_flow
 * @returns
 */
// 获取生态流量有两步
const flowDate = dayjs(new Date()).format('YYYY-MM-DD');
export function getEcologicalFlowStep1() {
  return request2(`/testApi/smallHydropower/api/doPostSecret`, {
    method: 'post',
    params: {
      paramUrl: '/smallHydropower/sunnyApi/selectRealTimeFlowPage',
      params: `?page=1&pageSize=1000&startTime=${flowDate}&name=高板岩一级`,
    },
  });
}
export function getEcologicalFlowStep2(query) {
  return request2(`/testApi/smallHydropower/sunnyApi/selectRealTimeFlowPage`, {
    method: 'get',
    headers: {
      appId: query.appId,
      key: query.key,
      signature: query.signature,
      timestamp: query.timestamp,
    },
    params: {
      page: 1,
      pageSize: 1000,
      startTime: flowDate,
      name: '高板岩一级',
    },
  });
}

export function getFlowValue(query) {
  return request(`/digital-twin-display/digital/baseInfo/getHistoryData`, {
    method: 'GET',
    params: query,
  });
}
// 最新获取实时前池水位接口
export function getHydroPower(query) {
  return request(`/hzims-operational/hydropower/station`, {
    method: 'GET',
    params: query,
  });
}

// 发电量完成百分比柱状图
export function getPowerDetail(query) {
  return request(`/digital-twin-display/digital/baseInfo/getPowerDetail`, {
    method: 'GET',
    params: query,
  });
}

// 前池水位
export function getBeforeWaterFlow(query) {
  return request(`/digital-twin-display/digital/baseInfo/getBeforeWaterFlow`, {
    method: 'GET',
    params: query,
  });
}

// 实时天气预报
export function getNowWeatherInfo(query) {
  return request(`/digital-twin-display/digital/baseInfo/getNowWeatherInfo`, {
    method: 'GET',
    params: query,
  });
}

// 7天天气预报
export function get7dWeatherInfo(query) {
  return request(`/digital-twin-display/digital/baseInfo/get7dWeatherInfo`, {
    method: 'GET',
    params: query,
  });
}

// 降雨量
export function getRainFallInfo(query) {
  return request(`/digital-twin-display/digital/baseInfo/getRainFallInfo`, {
    method: 'GET',
    params: query,
  });
}

// 实时水位-yes-无数据
export function getWaterLevel(query) {
  return request(`/digital-twin-display/digital/baseInfo/getWaterLevel`, {
    method: 'GET',
    params: query,
  });
}

// 设备设施-yes-有数据但不对
export function getStructTreeByStation(query) {
  return request(`/digital-twin-display/digital/baseInfo/getStructTreeByStation`, {
    method: 'GET',
    params: query,
  });
}

// 根据设备code获取设备详情 参数modelCode
export function getEmInfoByModelCode(query) {
  return request(`/digital-twin-display/digital/baseInfo/getEmInfoByModelCode`, {
    method: 'GET',
    params: query,
  });
}

// 获取设备实时信息接口 参数deviceCode

/**
 * 
 * @param {*} query  {deviceCode:'RR50705074'}
 * 大坝渗压数据：DAM50705074_FF
    位移实例：
    DAM507050741211
    DAM507050741212
    DAM507050741213
    获取库水位：RR50705074
 * @returns 
 */
export function getRealData(query) {
  return request(`/digital-twin-display/digital/baseInfo/getRealData`, {
    method: 'GET',
    params: query,
  });
}

// 水质预警
export function getWaterQualityAlarm(query) {
  return request(`/digital-twin-display/digital/baseInfo/getWaterQualityAlarm`, {
    method: 'GET',
    params: query,
  });
}

// 水情预警-no
export function getSurveyAlarm(query) {
  return request(`/digital-twin-display/digital/baseInfo/getSurveyAlarm`, {
    method: 'GET',
    params: query,
  });
}

// 大坝安全监测-no
export function getDamAlarm(query) {
  return request(`/digital-twin-display/digital/baseInfo/getDamAlarm`, {
    method: 'GET',
    params: query,
  });
}

// 大坝实时监控数据-no
export function getDamRealData(query) {
  return request(`/digital-twin-display/digital/baseInfo/getDamRealData`, {
    method: 'GET',
    params: query,
  });
}

// 故障诊断---------------------------

// 实时故障列表-no
export function getStationWarns(query) {
  return request(`/digital-twin-display/digital/baseInfo/stationWarns`, {
    // return request(`/hzims-operational/stAlamRecord/getFaultList`, {
    method: 'POST',
    data: query,
  });
}

// 第一步 列表库 带参数则是故障搜索 name= & stationId=  有分页
export function getFaultList(query) {
  return request(`/hzims-equipment/fdp/fault/queryFaultListOrd`, {
    method: 'GET',
    params: query,
  });
}

// 第二步 获取实例id
export function getRealTimeHisDataNew(query) {
  return request(`/hzims-equipment/fdp/monitor/updateFaultStateAll/getRealTimeHisDataNew`, {
    method: 'POST',
    data: query,
  });
}

// 待排查项列表  参数：传故障id
export function getNextstepData(query) {
  return request(`/hzims-equipment/fdp/monitor/getNextstepData`, {
    method: 'GET',
    params: query,
  });
}

// 查询状态 待排查项信息  参数：faultId=&stationId=
export function searchFaultStateByFault(query) {
  return request(`/hzims-equipment/fdp/diagnose/searchFaultStateByFault`, {
    method: 'GET',
    params: query,
  });
}

// 状态变更 post请求 confidence：1发生，0未发生;faultId:故障Id
export function updateFaultState(query) {
  return request(`/hzims-equipment/fdp/monitor/updateFaultState`, {
    method: 'POST',
    data: query,
  });
}

// 状态变更后刷新列表 fdpId,stationId
export function getNextStepWithTree(query) {
  return request(`/hzims-equipment/fdp/fault/getNextStepWithTree`, {
    method: 'POST',
    data: query,
  });
}

// 诊断完成
export function updateTask(query) {
  return request(`/hzims-equipment/fdp/task/update`, {
    method: 'POST',
    data: query,
  });
}

// 智能巡检-------------------------------------

// 巡检任务统计图-yes
export function getTaskCount(query) {
  return request(`/digital-twin-display/task/getTaskCount`, {
    method: 'GET',
    params: query,
  });
}

// 巡检任务统计图新-xyes
export function getTaskCountNew(query) {
  return request(`/digital-twin-display/task/getFinishTaskNum`, {
    method: 'GET',
    params: query,
  });
}

// 巡检任务列表-yes
export function getTaskList(query) {
  return request(`/digital-twin-display/task/getTaskList`, {
    method: 'GET',
    params: query,
  });
}
// 巡检任务列表新-yes
export function getTaskListNew(query) {
  return request(`/digital-twin-display/task/pageList`, {
    method: 'GET',
    params: query,
  });
}

// 获取回放视频-yes-有数据但不对
export function getReplayVideo(query) {
  return request(`/digital-twin-display/task/getReplayVideo`, {
    method: 'GET',
    params: query,
  });
}

// 获取回放数据
export function getReplayData(query) {
  const { recordTime } = query;
  return request(`/digital-twin-display/task/selectInspectionTaskByRecordTime/1/${recordTime}`, {
    method: 'GET',
    params: query,
  });
}

// 获取监控视频
export function getHikVides(query) {
  return request(`/digital-twin-display/task/getHikVides`, {
    method: 'GET',
    params: query,
  });
}

// 巡检问题数量 已处理、未处理、问题总数-yes
export function getProblemCount(query) {
  return request(`/digital-twin-display/task/getProblemCount`, {
    method: 'GET',
    params: query,
  });
}

// 问题列表以及搜索 不传参数是list 搜索参数:name
export function getProblemList(query) {
  return request(`/digital-twin-display/task/getProblemList`, {
    method: 'GET',
    params: query,
  });
}

// 17230100206
export function getHikFlvByStationCode(query) {
  return request(`/hzims-operational/station/videoType/getFlvStation`, {
    method: 'GET',
    params: { stationId: '17230100205', size: 30 },
  });
}
export function getFlvListEscape(query) {
  return request(`/video-image/videoImage/hikVideo/getFlvListEscape`, {
    method: 'GET',
    params: query,
  });
}

// 获取预演方案
export function getPreviewSchemeContent() {
  return request(`/digital-twin-display/digital/preview/previewSchemeContent`, {
    method: 'GET',
    params: { schemeId: 1 },
  });
}

// 巡检新接口
// 查询计划信息
export function getCheckPlanList(query) {
  return request(`/digital-twin-display/digital/plantask/planList`, {
    method: 'POST',
    data: { current: 1, size: 10 },
  });
}
// 查询计划详情
export function getCheckPlanDetail(query) {
  return request(`/digital-twin-display/digital/plantask/planDetail`, {
    method: 'GET',
    params: query,
  });
}

// 查询任务信息
export function getCheckRobotList(query) {
  return request(`/digital-twin-display/digital/plantask/robotList`, {
    method: 'POST',
    data: { current: 1, size: 10, status: 4 }, //状态3:已完成 4:未完成 先用4,正式有数据再换回3
  });
}
// 根据id查询任务
export function getCheckRobotById(query) {
  return request(`/digital-twin-display/digital/plantask/robotGetTaskById`, {
    method: 'GET',
    params: query,
  });
}
